export default __webpack_public_path__ + "static/media/sports-icon.9cff4b13.webp";